import React, { useState, useRef } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CToast,
  CToastHeader,
  CToastBody,
  CToaster,
} from "@coreui/react";

const MessageModal = ({
  visible,
  setVisibleMessageModal,
  addToast,
  message,
  title,
}) => {
  const [showChangelog, setShowChangelog] = useState({});

  const closeModal = () => {
    setVisibleMessageModal(false);
  };

  const toggleChangelog = (index) => {
    setShowChangelog((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div>
      <CModal
        alignment="center"
        visible={visible}
        onClose={() => {
          closeModal();
        }}
      >
        <CModalHeader onClose={() => closeModal()}>
          <CModalTitle>{title ? title : "Rejected Reason"}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {typeof message == "string"
            ? message
              ? message
              : "No Message to show"
            : ""}

          {typeof message == "object" ? (
            message && message.type && message.type == "deliver" ? (
              <div>
                <p>Receiver's Name: {message.deliverTo}</p>
                <p>Employee Code: {message.deliverEmployeeCode}</p>
                <p>
                  Signature:{" "}
                  <img
                    src={
                      message.deliverSignature ? message.deliverSignature : ""
                    }
                    width={100}
                  />
                </p>
                <p>
                  Image:{" "}
                  <img
                    src={message.deliverImage ? message.deliverImage : ""}
                    width={60}
                  />
                </p>
              </div>
            ) : (
              ""
            )
          ) : (
            ""
          )}

          {typeof message == "object" ? (
            message && message.type && message.type == "driver" ? (
              <div>
                <p>
                  Name: {message.firstName} {message.lastName}
                </p>
                {/* <p>Vehicle Id: {message.vehicleId}</p> */}
                {<p>Tag Id: {message?.tagId}</p>}
                <p>
                  Driver Image:{" "}
                  <img src={message.avatar ? message.avatar : ""} width={50} />
                </p>
              </div>
            ) : (
              ""
            )
          ) : (
            ""
          )}

          {typeof message == "object" ? (
            message && message.type && message.type == "history" ? (
              <div>
                <ol className="activity-feed">
                  {message.data.map((item, index) => (
                    <li key={index} className="feed-item">
                      <time className="date" dateTime="9-25">
                        {item.createdAt
                          ? new Date(item.createdAt).toLocaleDateString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                              }
                            )
                          : ""}
                      </time>
                      <span className="text">{item.message}</span>
                      <br />
                      {item.changelog &&
                        Array.isArray(item.changelog) &&
                        item.changelog.length > 0 && (
                          <>
                            <CButton
                              color="link"
                              className="p-0"
                              onClick={() => toggleChangelog(index)}
                            >
                              {showChangelog[index]
                                ? "Hide Changelog"
                                : "Show Changelog"}
                            </CButton>
                            {showChangelog[index] && (
                              <ul>
                                {item.changelog.map((change, idx) => (
                                  <li key={idx} className="uppercase">
                                    {change.key.charAt(0).toUpperCase() +
                                      change.key.slice(1)}
                                    :{" "}
                                    <span>
                                      {change.oldValue} -&gt; {change.newValue}
                                    </span>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </>
                        )}
                    </li>
                  ))}
                </ol>
              </div>
            ) : (
              ""
            )
          ) : (
            ""
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => closeModal()}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  );
};

export default MessageModal;
